export default [
  {
    path: '/d-:hashCode',
    name: 'downloadShare',
    component: () => import('@/views/DownloadSharePage.vue'),
    meta: {
      title: 'Download Files',
      requiresAuth: false, // Public download page
      hideNavigation: true // Hide main navigation for this page
    }
  }
];
